import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import { buildPublicUrl } from '../../utils/buildUrl';
import { fromBusinessLiteDto } from '../business/toBusinessModel';
import type { PostDto, PostModel } from '../../data-layer/posts/types';

export const toPostModel = (postDto: PostDto): PostModel => ({
    id: postDto.id,
    text: postDto.text,
    reactionState: postDto.reaction_state,
    saved: postDto.saved,
    likes: postDto.likes ?? 0,
    views: postDto.views ?? 0,
    clickouts: postDto.clickouts.map(
        (clickout) => mapKeys(clickout, (_, key) => camelCase(key)) as any,
    ),
    tags: postDto.tags,
    status: postDto.status,
    source: postDto.data_source,
    url: `/business/${postDto.business.public_id}/posts/${postDto.id}`,
    shareUrl: postDto.post_url,
    business: fromBusinessLiteDto(postDto.business),
    createdAt: postDto.created_at,
    djRequestId: postDto.dj_request_id,
    content: postDto.content.map((content) => {
        if (content.type === 'image') {
            return {
                id: content.id,
                type: 'image',
                media: content.media,
            };
        }

        return {
            id: content.id,
            type: 'video',
            media: content.media.map((file) => ({
                url: file.url,
                width: file.width,
                height: file.height,
                firstFrameHash: file.first_frame_hash,
                firstFrameUrl: file.first_frame_url ?? buildPublicUrl('/images/firstFrame.png'),
                previewFormats: file.preview_formats,
                streams: file.streams?.map((stream) => ({
                    stream: stream.url,
                    streamType: stream.stream_type,
                })),
                uuid: file.strm_content_id,
            })),
        };
    }),
});
